import saleReturnStatus from '../config/saleReturnStatus'

export default {

  filters: {
    
    saleReturnStatusToText (status) {
      
      let statusText = ""
      
      switch(status) {
        case saleReturnStatus.pending:
          statusText = "Pending"
        break
        case saleReturnStatus.confirmed:
          statusText = "Confirmed"
        break
        case saleReturnStatus.approved:
          statusText = "Approved"
        break
        case saleReturnStatus.cancelled:
          statusText = "Cancelled"
        break
      }

      return statusText

    }

  },

}
